import { BaseModel, HasId } from '@app/shared/models/base';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import * as _ from 'lodash-es';
import { TranslationEntry } from '@app/shared/models/translatable';


export enum VatCalculationEnum {
    NET = 'NET',
    GROSS = 'GROSS'
}

export enum TotalLoss {
    TOTAL_LOSS = 'TOTAL_LOSS',
    TOTAL_LOSS_ESTIMATED = 'TOTAL_LOSS_ESTIMATED',
    REPAIR = 'REPAIR'
}

export class TotalLossTypes {

    public static ALL: TranslationEntry[] = [
        { key: TotalLoss.TOTAL_LOSS, trans: marker('detailed_processing.results.total_loss_assessment.total_loss') },
        { key: TotalLoss.TOTAL_LOSS_ESTIMATED, trans: marker('detailed_processing.results.total_loss_assessment.total_loss_estimated') },
        { key: TotalLoss.REPAIR, trans: marker('detailed_processing.results.total_loss_assessment.repair') }
    ];

    public static getByKey(key: string): TranslationEntry {
        key = typeof key === 'string' ? key.toUpperCase() : key;
        const found = _.find(TotalLossTypes.ALL, (type: TranslationEntry) => type.key === key);
        return found || { key: null, trans: '' };
    }
d
    public static get TOTAL_LOSS() {
        return TotalLossTypes.getByKey(TotalLoss.TOTAL_LOSS);
    }

    public static get TOTAL_LOSS_ESTIMATED() {
        return TotalLossTypes.getByKey(TotalLoss.TOTAL_LOSS_ESTIMATED);
    }

    public static get REPAIR() {
        return TotalLossTypes.getByKey(TotalLoss.REPAIR);
    }
}

export enum ResultValuationTaxType {
    DIFFERENTIAL = 'DIFFERENTIAL',
    DIFFERENTIAL_24 = 'DIFFERENTIAL_24',
    NEUTRAL = 'NEUTRAL',
    REGULAR = 'REGULAR'
}

export class ResultValuationTaxTypes {

    public static ALL: TranslationEntry[] = [
        { key: ResultValuationTaxType.DIFFERENTIAL, trans: marker('detailed_processing.results.valuation_result_tax_type.differential') },
        { key: ResultValuationTaxType.DIFFERENTIAL_24, trans: marker('detailed_processing.results.valuation_result_tax_type.differential24') },
        { key: ResultValuationTaxType.NEUTRAL, trans: marker('detailed_processing.results.valuation_result_tax_type.neutral') },
        { key: ResultValuationTaxType.REGULAR, trans: marker('detailed_processing.results.valuation_result_tax_type.regular') }
    ];

    public static getByKey(key: string): TranslationEntry {
        key = typeof key === 'string' ? key.toUpperCase() : key;
        const found = _.find(ResultValuationTaxTypes.ALL, (type: TranslationEntry) => type.key === key);
        return found || { key: null, trans: '' };
    }

    public static get DIFFERENTIAL() {
        return ResultValuationTaxTypes.getByKey(ResultValuationTaxType.DIFFERENTIAL);
    }

    public static get DIFFERENTIAL_24() {
        return ResultValuationTaxTypes.getByKey(ResultValuationTaxType.DIFFERENTIAL_24);
    }

    public static get NEUTRAL() {
        return ResultValuationTaxTypes.getByKey(ResultValuationTaxType.NEUTRAL);
    }

    public static get REGULAR() {
        return ResultValuationTaxTypes.getByKey(ResultValuationTaxType.REGULAR);
    }
}

export enum ResultType {
    PRICE_SALVAGE = 'PRICE_SALVAGE',
    PRICE_ORIGINAL = 'PRICE_ORIGINAL',
    PRICE_MARKET = 'PRICE_MARKET',
    COSTS_CONVERSION = 'COSTS_CONVERSION',
    COSTS_TEMPORARY_REPAIR = 'COSTS_TEMPORARY_REPAIR',
    COSTS_DISPOSAL = 'COSTS_DISPOSAL',
    RENTAL_CAR = 'RENTAL_CAR',
    COSTS_CONTINGENCY = 'COSTS_CONTINGENCY',
    ACTUAL_CASH = 'ACTUAL_CASH',
    PURCHASE_PRICE = 'PURCHASE_PRICE',
    REPLACEMENT = 'REPLACEMENT',
    SELLING_PRICE = 'SELLING_PRICE',
    COSTS_REPAIR = 'COSTS_REPAIR',
    CLAIMS_AMOUNT = 'CLAIMS_AMOUNT'
}

export class ResultTypes {

    public static ALL: TranslationEntry[] = [
        { key: ResultType.ACTUAL_CASH, trans: marker('detailed_processing.results.valuation_result_type.actual_cash') },
        { key: ResultType.PURCHASE_PRICE, trans: marker('detailed_processing.results.valuation_result_type.purchase_price') },
        { key: ResultType.REPLACEMENT, trans: marker('detailed_processing.results.valuation_result_type.replacement') },
        { key: ResultType.SELLING_PRICE, trans: marker('detailed_processing.results.valuation_result_type.selling_price') },

        { key: ResultType.PRICE_SALVAGE, trans: marker('detailed_processing.results.further_types.price_salvage') },
        { key: ResultType.PRICE_ORIGINAL, trans: marker('detailed_processing.results.further_types.price_original') },
        { key: ResultType.PRICE_MARKET, trans: marker('detailed_processing.results.further_types.price_market') },
        { key: ResultType.COSTS_CONVERSION, trans: marker('detailed_processing.results.further_types.costs_conversion') },
        { key: ResultType.COSTS_TEMPORARY_REPAIR, trans: marker('detailed_processing.results.further_types.temporary_repair') },
        { key: ResultType.COSTS_DISPOSAL, trans: marker('detailed_processing.results.further_types.costs_disposal') },
        { key: ResultType.RENTAL_CAR, trans: marker('detailed_processing.results.further_types.rental_car') },
        { key: ResultType.COSTS_CONTINGENCY, trans: marker('detailed_processing.results.further_types.costs_contingency') }
    ];

    public static getByKey(key: string): TranslationEntry {
        key = typeof key === 'string' ? key.toUpperCase() : key;
        const found = _.find(ResultTypes.ALL, (type: TranslationEntry) => type.key === key);
        return found || { key: null, trans: '' };
    }

    public static get VALUATION_RESULT_TYPES() {
        return [
            ResultTypes.ACTUAL_CASH,
            ResultTypes.PURCHASE_PRICE,
            ResultTypes.REPLACEMENT,
            ResultTypes.SELLING_PRICE
        ];
    }

    public static get GENERAL_RESULT_TYPES() {
        return [
            ResultTypes.PRICE_SALVAGE,
            ResultTypes.PRICE_ORIGINAL,
            ResultTypes.PRICE_MARKET,
            ResultTypes.COSTS_CONVERSION,
            ResultTypes.COSTS_TEMPORARY_REPAIR,
            ResultTypes.COSTS_DISPOSAL,
            ResultTypes.RENTAL_CAR,
            ResultTypes.COSTS_CONTINGENCY
        ];
    }

    public static get ACTUAL_CASH() {
        return ResultTypes.getByKey(ResultType.ACTUAL_CASH);
    }

    public static get PURCHASE_PRICE() {
        return ResultTypes.getByKey(ResultType.PURCHASE_PRICE);
    }

    public static get REPLACEMENT() {
        return ResultTypes.getByKey(ResultType.REPLACEMENT);
    }

    public static get SELLING_PRICE() {
        return ResultTypes.getByKey(ResultType.SELLING_PRICE);
    }

    public static get PRICE_SALVAGE() {
        return ResultTypes.getByKey(ResultType.PRICE_SALVAGE);
    }

    public static get PRICE_ORIGINAL() {
        return ResultTypes.getByKey(ResultType.PRICE_ORIGINAL);
    }

    public static get PRICE_MARKET() {
        return ResultTypes.getByKey(ResultType.PRICE_MARKET);
    }

    public static get COSTS_CONVERSION() {
        return ResultTypes.getByKey(ResultType.COSTS_CONVERSION);
    }
    public static get COSTS_TEMPORARY_REPAIR() {
        return ResultTypes.getByKey(ResultType.COSTS_TEMPORARY_REPAIR);
    }

    public static get COSTS_DISPOSAL() {
        return ResultTypes.getByKey(ResultType.COSTS_DISPOSAL);
    }

    public static get RENTAL_CAR() {
        return ResultTypes.getByKey(ResultType.RENTAL_CAR);
    }

    public static get COSTS_CONTINGENCY() {
        return ResultTypes.getByKey(ResultType.COSTS_CONTINGENCY);
    }
}

export class CaseResult extends BaseModel implements HasId {

    get id() {
        return this.caseId;
    }

    public caseId: string;

    public last_modification_date: Date;
    public last_modification_username: string;

    public calculation: CaseResultCalculation;
    public general: CaseResultGeneral;
    public valuation: CaseResultValuation;

    public additions: CaseResultValues[];

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            last_modification_date: json && json.last_modification_date ? new Date(json.last_modification_date) : null,
            calculation: new CaseResultCalculation(json && json.calculation),
            general: new CaseResultGeneral(json && json.general),
            valuation: new CaseResultValuation(json && json.valuation),
            additions: json && json.additions ? json.additions.map(result => new CaseResultValues(result)) : []
        });
    }
}

export interface CaseResultCalculationSummary {
    appreciation: number;
    claims_amount_net: number;
    claims_amount_gross: number;
    costs_repair_gross: number;
    costs_repair_net: number;
    reduced_market_value_assessor: number;

    trans: {
        appreciation: string;
        claims_amount_net_gross: string,
        costs_repair_net_gross: string,
        reduced_market_value_assessor: string
    };
}

export class CaseResultCalculation extends BaseModel
                                   implements CaseResultCalculationSummary {
    public appreciation: number;
    public claims_amount_net: number;
    public claims_amount_tax: number;
    public claims_amount_gross: number;
    public deductions: number;
    public costs_repair_gross: number;
    public costs_repair_net: number;
    public costs_repair_tax: number;
    public reduced_market_value_assessor: number;
    public comment: string;

    constructor(json?: any) {
        super(json);
    }

    public readonly trans = {
        appreciation: marker('case.result.calculation.appreciation'),
        claims_amount_gross: marker('case.result.calculation.claims_amount_gross'),
        claims_amount_net: marker('case.result.calculation.claims_amount_net'),
        claims_amount_net_gross: marker('case.result.calculation.claims_amount_net_gross'),
        claims_amount_tax: marker('case.result.calculation.claims_amount_tax'),
        deductions: marker('case.result.calculation.deductions'),
        costs_repair_gross: marker('case.result.calculation.costs_repair_gross'),
        costs_repair_net: marker('case.result.calculation.costs_repair_net'),
        costs_repair_net_gross: marker('case.result.calculation.costs_repair_net_gross'),
        costs_repair_tax: marker('case.result.calculation.costs_repair_tax'),
        reduced_market_value_assessor: marker('case.result.calculation.reduced_market_value_assessor'),
        comment: marker('case.result.calculation.comment')
    };
}

export interface NetTaxGross {
   net: number;
   tax: number;
   gross: number;
}

export class ResultValues extends BaseModel implements NetTaxGross {
    public net: number;
    public tax: number;
    public gross: number;
    public comment: string;

    public readonly trans = {
        net: marker('case.result.net'),
        tax: marker('case.result.tax'),
        gross: marker('case.result.gross'),
        comment: marker('case.result.comment')
    };

    constructor(json?: any) {
        super(json);
    }

    public static getNetGrossCalculationTooltip(vehicleTaxPercentage: number, taxType: VatCalculationEnum, net: number, gross: number): string {
        if (!vehicleTaxPercentage) {
            return marker('detailed_processing.results.message.calculate_vehicle_tax_percentage_missing');
        } else {
            if (taxType === VatCalculationEnum.GROSS) {
                if (net) {
                    return marker('detailed_processing.results.message.calculate_tax_and_gross');
                } else {
                    return marker('detailed_processing.results.message.calculate_net_missing');
                }
            } else if (taxType === VatCalculationEnum.NET) {
                if (gross) {
                    return marker('detailed_processing.results.message.calculate_tax_and_net');
                } else {
                    return marker('detailed_processing.results.message.calculate_gross_missing');
                }
            }
        }
    }

    public hasValues(): boolean {
        return !!(this.net || this.tax || this.gross || this.comment);
    }

}


export class CaseResultValues extends ResultValues
                              implements HasId {

    public id: string;
    public result_type_id: ResultType;
    public result_type: string;
    public group: string;

    get showGroupFields(): boolean {
        return this.result_type_id === ResultType.RENTAL_CAR || this.result_type_id === ResultType.COSTS_CONTINGENCY;
    }

    get grossLabel(): string {
        return this.showGroupFields ? this.trans.cost_per_day : this.trans.gross;
    }

    public readonly trans = Object.assign(this.trans, {
        result_type_id: marker('case.result.result_type_id'),
        group: marker('case.result.group'),
        cost_per_day: marker('case.result.cost_per_day')
    });

    constructor(json?: any) {
        super(json);
    }
}

export class CaseResultValuation extends CaseResultValues {
    public tax_type_id: ResultValuationTaxType;
    public tax_type: string;
    public case_id: string;
    public client_id: string;

    public readonly trans = Object.assign(this.trans, {
        valuation_type: marker('case.result.valuation_type'),
        tax_type_id: marker('case.result.tax_type_id')
    });

    constructor(json?: any) {
        super(json);
    }
}

export class CaseResultGeneral extends BaseModel {
    public assessment_id: TotalLoss;
    public assessment: string;

    public duration_repair: string;
    public duration_replacement: string;
    public deductible_fullcoverage: number;
    public deductible_partialcoverage: number;

    public notice_of_assignment: boolean;
    public tax_percentage: number;

    public repair_approval: boolean;

    public delivery_date: Date;

    public readonly trans = {
        deductible_fullcoverage: marker('case.result.general.deductible_fullcoverage'),
        deductible_partialcoverage: marker('case.result.general.deductible_partialcoverage'),
        duration_repair: marker('case.result.general.duration_repair'),
        duration_repair_unit: marker('case.result.general.duration_repair_unit'),
        duration_replacement: marker('case.result.general.duration_replacement'),
        notice_of_assignment: marker('case.result.general.notice_of_assignment'),
        repair_approval: marker('case.result.general.repair_approval'),
        tax_percentage: marker('case.result.general.tax_percentage'),
        assessment_id: marker('case.result.general.assessment_id'),
        delivery_date: marker('case.result.general.delivery_date')
    };

    constructor(json?: any) {
        super(json);
    }

}

export class ResultSummary extends BaseModel {
    public car_sales: number;
    public downtime_costs: number;
    public downtime_gross: number;
    public downtime_group: string;
    public leasing_transfer_costs: number;
    public registration_costs: number;
    public rental_car_costs: number;
    public rental_car_gross: number;
    public rental_car_group: string;
    public replacement_value_gross: number;
    public replacement_value_net: number;
    public replacement_value_tax: number;
    public salvage_potential: number;
    public salvage_value_gross: number;
    public tax_type: string;
    public tax_type_id: string;
    public towing_costs: number;

    public calculation: CaseResultCalculationSummary;
    public sums: ResultSummarySums;

    public readonly trans = {
        car_sales: marker('result_summary.car_sales'),
        downtime_costs: marker('result_summary.downtime_costs'),
        downtime_costs_group_price: marker('result_summary.downtime_costs_group_price'),
        leasing_transfer_costs: marker('result_summary.leasing_transfer_costs'),
        registration_costs: marker('result_summary.registration_costs'),
        rental_car_costs: marker('result_summary.rental_car_costs'),
        rental_car_costs_group_price: marker('result_summary.rental_car_costs_group_price'),
        replacement_value_net_gross: marker('result_summary.replacement_value_net_gross'),
        replacement_value_gross: marker('result_summary.replacement_value_gross'),
        salvage_value_gross: marker('result_summary.salvage_value_gross'),
        salvage_potential: marker('result_summary.salvage_potential'),
        towing_costs: marker('result_summary.towing_costs')
    };

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            calculation: new CaseResultCalculation(json && json.calculation),
            sums: new ResultSummarySums(json && json.sums)
        });
    }
}

export class ResultSummarySums extends BaseModel {
    public costs_repair_net_reduced_marketvalue:  number;
    public leasing_transfer_replacement_value:  number;
    public salvage_value_potential: number;
    public subtotal1: number;
    public replacement_costs: number;

    public readonly trans = {
        costs_repair_net_reduced_marketvalue: marker('result_summary_sums.costs_repair_net_reduced_marketvalue'),
        replacement_costs: marker('result_summary_sums.replacement_costs')
    };

    constructor(json?: any) {
        super(json);
    }
}
